import { styled } from "styled-components";
const TabBarWrapper = styled("div")(({ theme }) => ({
  alignItems: "flex-end",
  backgroundColor: theme.color.monochrome2,
  boxSizing: "content-box",
  display: "flex",
  flex: "0 0 auto",
  height: 41,
  padding: "0 8px",
  position: "relative",
  "&::before": {
    backgroundColor: theme.color.monochrome4,
    bottom: 0,
    content: JSON.stringify(""),
    height: 1,
    left: 0,
    position: "absolute",
    right: 0
  }
}));
export {
  TabBarWrapper
};
